import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import getStore from '../store/store';

export default function getSharingLink(linkId: string): SharingLinkInfo {
    const store = getStore();
    return store.sharingLinks.get(linkId);
}
